import React from 'react';
import Input, { InputProps } from '@wix/da-shared-react/pkg/Input';
import { useTranslation } from 'react-i18next';

import * as s from './SearchInputField.skin.scss';

export const SearchInputField: React.FC<InputProps> = props => {
  const { t } = useTranslation();
  return (
    <Input
      {...props}
      autoFocus
      fullWidth
      placeholder={t('pages.gallections.search.whatAreYouLookingFor')}
      skin={{
        'input-layout-paddings': s['input-layout-paddings'],
        'input-layout-content': s['input-layout-content'],
        input: s['input-field'],
        focused: s['input-focused'],
        bar: s['input-bar'],
      }}
    />
  );
};
SearchInputField.displayName = 'SearchInputField';

export default SearchInputField;
